module.exports = __webpack_public_path__ + "static/media/document-white.4fcc858c.svg";